<template>
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>Logistics Request Form</v-card-title>
          <v-card-text>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                v-model="request.fleetType"
                :items="fleetTypes"
                label="Type of Fleet"
                required
                :rules="[v => !!v || 'Fleet type is required']"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                v-model="request.customerName"
                label="Customer / Supplier / Person Name"
                required
                :rules="[v => !!v || 'Name is required']"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="request.fromLocation"
                  label="From Location"
                  required
                  :rules="[v => !!v || 'From location is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="request.fromGeolocation"
                  label="From Geolocation"
                  required
                  :rules="[v => !!v || 'From geolocation is required']"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="fromDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="request.fromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[v => !!v || 'From date is required']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="request.fromDate"
                    @input="fromDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="fromTimeMenu"
                  v-model="fromTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="request.fromTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="request.fromTime"
                      label="From Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[v => !!v || 'From time is required']"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="fromTimeMenu"
                    v-model="request.fromTime"
                    full-width
                    format="24hr"
                    @click:minute="$refs.fromTimeMenu.save(request.fromTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="request.toLocation"
                  label="To Location"
                  required
                  :rules="[v => !!v || 'To location is required']"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="request.toGeolocation"
                  label="To Geolocation"
                  required
                  :rules="[v => !!v || 'To geolocation is required']"
                ></v-text-field>
              </v-col>
            </v-row>
  
            <v-row>
              <v-col cols="12" md="6">
                <v-menu
                  v-model="toDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="request.toDate"
                      label="To Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[v => !!v || 'To date is required']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="request.toDate"
                    @input="toDateMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="6">
                <v-menu
                  ref="toTimeMenu"
                  v-model="toTimeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="request.toTime"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="request.toTime"
                      label="To Time"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[v => !!v || 'To time is required']"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="toTimeMenu"
                    v-model="request.toTime"
                    format="24hr"
                    full-width
                    @click:minute="$refs.toTimeMenu.save(request.toTime)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                v-model="request.priority"
                :items="priorities"
                label="Priority"
                required
                :rules="[v => !!v || 'Priority is required']"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                v-model="request.requestedBy"
                label="Requested By"
                required
                :rules="[v => !!v || 'Requester name is required']"
                ></v-text-field>
                </v-col>
            </v-row> 
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="submitForm"
              :disabled="!valid"
            >
              Submit Request
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-container>
  </template>
  
  <script>
  export default {

    data() {
    return {
        valid: true,
        fromDateMenu: false,
        fromTimeMenu: false,
        toDateMenu: false,
        toTimeMenu: false,
        fleetTypes: ['Pick Up', 'Drop Off', 'Goods Delivery', 'Collection', 'Return', 'Transfer'],
        priorities: ['Urgent', 'High', 'Normal', 'Low'],
        request: {
            fleetType: '',
            customerName: '',
            fromLocation: '',
            fromGeolocation: '',
            fromDate: '',
            fromTime: '',
            toLocation: '',
            toGeolocation: '',
            toDate: '',
            toTime: '',
            priority: '',
            requestedBy: '',
        },
        };
    }, 
    methods: {
      submitForm() {
        if (this.$refs.form.validate()) {
          // Here you would typically use your axios instance to send the request
          console.log('Form submitted:', this.request);
          // Example of how you might use axios:
          // this.$axios.post('/api/logistics-request', this.request)
          //   .then(response => {
          //     console.log('Request submitted successfully', response);
          //   })
          //   .catch(error => {
          //     console.error('Error submitting request', error);
          //   });
        }
      },
    },
  }
  </script>